import React, { Component } from 'react';
import { readPublicMetadata } from '../../../../api/publicMetadata';

export default class CrowdFundingBar extends Component {
    constructor(props) {
        super(props);
        this.state = {
            supportersUrl: '',
        };
    }

    componentDidMount() {
        readPublicMetadata()
            .then((metadata) => this.setState({ supportersUrl: metadata.supportersUrl }))
            .catch(() => {});
    }

    handleClick(e, href) {
        window.open(href, "_blank");
    }

    render() {
        const { supportersUrl } = this.state;

        return (
            <div className="socialForTop">
                <div className="contact">
                    <p className="footerMessage">Hey, você!</p>
                    <p className='footerMessage'>Quer se tornar um aventureiro da guilda do Dragão Careca? </p>
                    <div className="emailBox">Nos apoie se inscrevendo <a href={supportersUrl} >aqui! </a></div>
                    <br />
                </div>
            </div>
        );
    }
}
